import { defineRule, configure } from "vee-validate";
import { email, required } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import builtIn from "./modules/locale/translations/built-in";
// Define the rule globally
defineRule("required", required);
defineRule("email", email);
configure({
  generateMessage: localize({
    en: {
      messages: {
        required: builtIn.en.requiredErrorMessage,
        email: builtIn.en.invalidEmailErrorMessage,
      },
    },
    ar: {
      messages: {
        required: builtIn.ar.requiredErrorMessage,
        email: builtIn.ar.invalidEmailErrorMessage,
      },
    },
    fr: {
      messages: {
        required: builtIn.fr.requiredErrorMessage,
        email: builtIn.fr.invalidEmailErrorMessage,
      },
    },
    es: {
      messages: {
        required: builtIn.es.requiredErrorMessage,
        email: builtIn.es.invalidEmailErrorMessage,
      },
    },
    nl: {
      messages: {
        required: builtIn.nl.requiredErrorMessage,
        email: builtIn.nl.invalidEmailErrorMessage,
      },
    },
    ti: {
      messages: {
        required: builtIn.ti.requiredErrorMessage,
        email: builtIn.ti.invalidEmailErrorMessage,
      },
    },
  }),
});
